/**
 * Turns the epoch millis a stored `date` or `dateRange` holds into the Dayjs its
 * DatePicker displays. Consumers: `ControlUI`'s `dayjsValue` and
 * `rangeDayjsValue`, `CsvImportModal`'s preview.
 *
 * Reads the calendar day in `defaultTimeZone`, the zone `dateOnlyTimestamp`
 * anchors to, and rebuilds it as browser-local midnight, so
 * `dateOnlyDayjs(dateOnlyTimestamp(d).toMillis())` lands on `d`'s day in every
 * browser zone. `dayjs(millis)` instead shows the previous day west of Chicago,
 * where Central midnight is still yesterday evening. A cell a non-Central
 * browser wrote before SYD-2507 sits at that browser's midnight and now reads as
 * the Central day, which is the day Signify and the Excel export already used.
 */
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';
import { DateTime } from 'luxon';
import { defaultTimeZone } from '#types/Client.Parameters.types';

export const dateOnlyDayjs = (millis: number): Dayjs => {
  const day = DateTime.fromMillis(millis, { zone: defaultTimeZone });
  return dayjs(new Date(day.year, day.month - 1, day.day));
};
